"use strict";
var Observable_1 = require('../../Observable');
var switch_1 = require('../../operator/switch');
Observable_1.Observable.prototype.switch = switch_1._switch;
Observable_1.Observable.prototype._switch = switch_1._switch;
//# sourceMappingURL=switch.js.map


//////////////////
// WEBPACK FOOTER
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/~/rxjs/add/operator/switch.js
// module id = ../../../../rxjs/add/operator/switch.js
// module chunks = 6